import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useCardContentStyles = makeStyles({
  container: {
    boxSizing: 'border-box',
    ...shorthands.overflow('hidden'),
    ...shorthands.padding(tokens.spacingVerticalL, tokens.spacingHorizontalL),
    ...shorthands.transition([
      ['max-height', tokens.durationNormal, '0', tokens.curveDecelerateMax],
      ['padding', tokens.durationNormal, '0', tokens.curveDecelerateMax],
    ]),
  },
  uncollapsableContainer: {
    paddingTop: 0,
  },
  content: {
    opacity: 1,
    ...shorthands.transition('opacity', tokens.durationNormal, '0', tokens.curveDecelerateMax),
  },
  contentHidden: {
    visibility: 'hidden',
    opacity: 0,
  },
  hidden: {
    maxHeight: '0px',
    ...shorthands.padding('0px', tokens.spacingHorizontalL),
  },
});
